import { render } from "./TaiXeVanHang.vue?vue&type=template&id=5cfb71c4&scoped=true"
import script from "./TaiXeVanHang.vue?vue&type=script&lang=js"
export * from "./TaiXeVanHang.vue?vue&type=script&lang=js"

import "./TaiXeVanHang.vue?vue&type=style&index=0&id=5cfb71c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb71c4"]])

export default __exports__